import React from 'react';
import { Text } from '@rsos/base-components';
import useShouldRenderOnsiteNotifications from '../../hooks/useShouldRenderOnsiteNotifications';

/**
 * Component that renders if a caller ID's location lands inside of a connected
 * building if user has access to the feature
 * @param {String} callerId - caller ID
 */
const OnsitePersonnelNotifiedText = ({ callerId }) => {
  const shouldRenderOnsiteNotifications =
    useShouldRenderOnsiteNotifications(callerId);

  if (shouldRenderOnsiteNotifications) {
    return (
      <Text
        mt="4px"
        color="heavyWarning"
        size="small"
        textTransform="uppercase"
      >
        Onsite Personnel Notified
      </Text>
    );
  }
  return null;
};

export default React.memo(OnsitePersonnelNotifiedText);
